<template>
    <div>
        <h1 style="font-size: 24px; color: black;">推荐管理 </h1>
        <h1>
            <el-table :data="positionList"
                      border
                      :fit="true">
                <el-table-column label="位置ID" prop="id" align="center"></el-table-column>
                <el-table-column label="位置名称" prop="name" align="center"></el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isOpen === true" class="sub-sub" type="success"
                                   @click="editPosition(scope.row)">已启用
                        </el-button>
                        <el-button v-if="scope.row.isOpen === false" class="sub-sub" type="danger"
                                   @click="editPosition(scope.row)">已禁用
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
<!--                        <el-button plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>-->
                        <el-button plain size="mini" type="primary" @click="activityManager(scope.row)">活动管理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="addPositionForm">
                <el-form-item label="位置名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addPositionForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="是否开启 :" :label-width="labelWidth">
                    <el-switch v-model="addPositionForm.isOpen"
                               :active-value=1
                               :inactive-value=0
                               active-text="开启"
                               inactive-text="关闭">
                    </el-switch>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm">提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
/*import app from "@/App.vue";*/
import {allOperationPosition, editOperationPosition} from "@/http/iosApi";
import objUtil from "@/utils/ObjUtil";

export default {
    name: "OperationConfigKitty",
    data() {
        return {
            positionList: [],
            dialogVisible: false,
            dialogTitle: '',
            labelWidth: '110px',
            addPositionForm: {
                id: 0,
                name: '',
                isOpen: 1,
            },
        }
    },
    methods: {
        showDetails(title,row) {
            this.addPositionForm = {
                "id": 0,
                "name": "",
                "isOpen": 1,
                "ranking": 1
            };
            this.dialogTitle = title;
            this.dialogVisible = true;
            if (row) {
                this.addPositionForm = objUtil.clone(row)
                // console.log(this.form.formData)
            }
        },

        editPosition(_data) {
            this.$confirm('此操作将改变位置状态, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.addPositionForm.id = _data.id;
                this.addPositionForm.name = _data.name;
                this.addPositionForm.isOpen = _data.isOpen !== true;
                editOperationPosition(this.addPositionForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryPosition();
                    }
                });
            }).catch(() => {
            })
        },
        confirmForm() {
            let _message = '';
            if (this.addPositionForm.name === '') {
                _message = '请输入位置名称'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            editOperationPosition(this.addPositionForm).then(resp => {
                if (resp.data.status === 0) {
                    this.queryPosition();
                    this.dialogVisible = false;
                }
            });
        },
        activityManager(_data) {
            this.$store.commit('position', _data);
            this.$router.push({path: '/operationConfigDetailKitty'});
        },
        queryPosition() {
            allOperationPosition().then(resp => {
                this.positionList = resp.data.info;
            })
        }
    },
    created() {
        this.queryPosition();
    }
}
</script>

<style scoped>

</style>